import { Injectable } from "@angular/core";
import { CertificationInput as CertificationInputDto } from "src/app/proxy/certifications/models";
import { CertificationInput } from "../../entities/certification-input";
import { LocalDbService } from "../local-db-service";

@Injectable({ providedIn: 'root' })
export class CertificationInputRepository {
  private get table() {
    return this.db.certificationInputsTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<CertificationInput[]> {
    return await this.table.toArray();
  }

  async getAllByProjectId(projectId: number): Promise<CertificationInput[]> {
    return await this.table.where('projectId').equals(projectId).toArray();
  }

  async getAllByRoadId(roadId: number): Promise<CertificationInput[]> {
    return await this.table.where('roadId').equals(roadId).toArray();
  }

  async getAllByActivityReportId(activityReportId: string): Promise<CertificationInput[]> {
    return await this.table.where('activityReportId').equals(activityReportId).toArray();
  }

  async upsertBulk(inputs: Array<CertificationInput | CertificationInputDto>): Promise<void> {
    if (inputs.length === 0) {
      return;
    }

    const rows = inputs.map(input => new CertificationInput(input));
    await this.table.bulkPut(rows);
  }

  async delete(id: number): Promise<void> {
    await this.table.delete(id);
  }

  async clear(): Promise<void> {
    await this.table.clear();
  }
}
